import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { RenderCheckboxRadioField } from '../../form';

function RenderEventInvitation({
  eventInvitation,
  eventFormValues,
  index,
  handleEventInvitation,
  disabled,
}) {
  const event = eventFormValues[index];
  let trimmedEventName = '';
  if (eventFormValues && eventFormValues[index].name) {
    const { name } = eventFormValues[index];
    trimmedEventName = name.length > 30 ? `${name.slice(0, 30)}...` : name;
  }

  return (
    <Field
      id={eventInvitation}
      name={`${eventInvitation}.checked`}
      component={RenderCheckboxRadioField}
      label={trimmedEventName}
      type="checkbox"
      styleOverride
      inline
      checkedOverride
      checked={event.checked === true}
      onChangeAction={() => handleEventInvitation(event, index)}
      disableDefaultAction
      className={disabled ? 'checkbox-disabled' : 'checkbox-secondary'}
      disabled={disabled}
    />
  );
}

RenderEventInvitation.propTypes = {
  eventInvitation: PropTypes.string,
  index: PropTypes.number,
  eventFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  handleEventInvitation: PropTypes.func,
  disabled: PropTypes.bool,
};

export default RenderEventInvitation;



// WEBPACK FOOTER //
// ./src/components/common/modals/EditGuestGroupWeddingsModal/RenderEventInvitation.jsx